/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_New_Term_Added_ToastInputs */

const en_knp_lookup_new_term_added_toast = /** @type {(inputs: Knp_Lookup_New_Term_Added_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New term added`)
};

const fr_knp_lookup_new_term_added_toast = /** @type {(inputs: Knp_Lookup_New_Term_Added_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau terme ajoute`)
};

const de_knp_lookup_new_term_added_toast = /** @type {(inputs: Knp_Lookup_New_Term_Added_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Begriff hinzugefügt`)
};

const it_knp_lookup_new_term_added_toast = /** @type {(inputs: Knp_Lookup_New_Term_Added_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo termine aggiunto`)
};

const ru_knp_lookup_new_term_added_toast = /** @type {(inputs: Knp_Lookup_New_Term_Added_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавлен новый термин`)
};

const es_knp_lookup_new_term_added_toast = /** @type {(inputs: Knp_Lookup_New_Term_Added_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo término añadido`)
};

const zh_cn2_knp_lookup_new_term_added_toast = /** @type {(inputs: Knp_Lookup_New_Term_Added_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增术语`)
};

const ja_knp_lookup_new_term_added_toast = /** @type {(inputs: Knp_Lookup_New_Term_Added_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい用語が追加されました`)
};

const hi_knp_lookup_new_term_added_toast = /** @type {(inputs: Knp_Lookup_New_Term_Added_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया शब्द जोड़ा गया`)
};

const pt_pt2_knp_lookup_new_term_added_toast = /** @type {(inputs: Knp_Lookup_New_Term_Added_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo termo adicionado`)
};

/**
* | output |
* | --- |
* | "New term added" |
*
* @param {Knp_Lookup_New_Term_Added_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_new_term_added_toast = /** @type {((inputs?: Knp_Lookup_New_Term_Added_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_New_Term_Added_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_new_term_added_toast(inputs)
	if (locale === "de") return de_knp_lookup_new_term_added_toast(inputs)
	if (locale === "it") return it_knp_lookup_new_term_added_toast(inputs)
	if (locale === "ru") return ru_knp_lookup_new_term_added_toast(inputs)
	if (locale === "es") return es_knp_lookup_new_term_added_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_new_term_added_toast(inputs)
	if (locale === "ja") return ja_knp_lookup_new_term_added_toast(inputs)
	if (locale === "hi") return hi_knp_lookup_new_term_added_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_new_term_added_toast(inputs)
	return en_knp_lookup_new_term_added_toast(inputs)
});